<template>
	<v-layout row wrap class="quotes">
		<documents-display
			type="Quotes"
			:display-qty="displayQty"
			:grid="true"
			title="QUOTES | In Progress"
		></documents-display>
	</v-layout>
</template>

<script>
import { mapActions } from "vuex";
import DocumentsDisplay from "@components/partials/DocumentsDisplay";

export default {
	components: { DocumentsDisplay },
	computed: {
		displayQty() {
			switch (this.$vuetify.breakpoint.name) {
				case "xs":
					return 2;
				case "sm":
					return 4;
				case "md":
					return 6;
				case "lg":
				case "xl":
					return 8;
			}
		}
	},

	methods: {
		...mapActions("documents", {
			GET_DOCUMENTS: "getDocuments"
		}),
	},

	created() {
		this.GET_DOCUMENTS({
			params: {
				orderby: "proposal_date"
			}
		});
	}
};
</script>
